<template>
  <v-dialog :model-value="isOpen" width="560" persistent>
    <v-card class="pa-6">
      <div class="d-flex align-start justify-space-between mb-4">
        <h3 class="dialog-title">Start your own subscription</h3>
        <v-icon class="cursor-pointer" color="#61676E" @click="$emit('close')">mdi-close</v-icon>
      </div>

      <p class="dialog-text mb-3">
        You'll set up your own Qlerify subscription and leave
        <span class="font-weight-bold" v-if="payerEmail">{{ payerEmail }}</span>
        <span class="font-weight-bold" v-else>the current</span>
        plan. You'll be asked for your payment details on the next step.
      </p>
      <p class="dialog-text mb-4">
        Your projects, workflows and team memberships stay exactly as they are - only billing moves to you.
        This means you keep access even if {{ payerEmail ? 'the' : 'your' }} payer's plan ends.
      </p>

      <p class="dialog-label mb-2">Choose your plan</p>
      <v-radio-group v-model="selectedPlanValue" hide-details>
        <v-radio v-for="plan in PLANS" :key="plan.value" :value="plan.value">
          <template #label>
            <span><strong>{{ plan.name }}</strong> - from ${{ plan.monthlyPrice }}/user/month</span>
          </template>
        </v-radio>
      </v-radio-group>

      <div class="d-flex justify-end ga-2 mt-6">
        <v-btn variant="outlined" size="large" @click="$emit('close')">
          Cancel
        </v-btn>
        <v-btn variant="flat" size="large" @click="$emit('confirm', selectedPlanValue)">
          Continue
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch } from 'vue'
import { PLANS } from '@/utils/payments'

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
    default: false
  },
  payerEmail: {
    type: String,
    default: ''
  },
  currentPlanValue: {
    type: String,
    default: 'pro'
  }
})

defineEmits(['close', 'confirm'])

const selectedPlanValue = ref(props.currentPlanValue || 'pro')

watch(() => props.isOpen, (open) => {
  if (open) {
    selectedPlanValue.value = props.currentPlanValue || 'pro'
  }
})
</script>

<style scoped>
.dialog-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-dark, #1D1F22);
}

.dialog-text {
  font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
  color: var(--text-dark);
}

.dialog-label {
  font-size: 14px;
  font-weight: 600;
  color: var(--dark-3, #61676E);
}
</style>
